import { ActionButton, Icon } from 'ui'
import styles from '@styles/components/ActiveLayerToggleButton.module.scss'
import { useProjectState } from '@hooks/useProject'
import CubeIcon from '/public/s2_icon_cube.svg'
import TwoDSDFIcon from '/public/icon_2d_sdf.svg'
import { useTranslations } from 'use-intl'
import { useSceneActions } from '@hooks/useScene'
import { useActiveLayer } from '@hooks/useActiveLayer'

export function ActiveLayerToggleButton() {
  const t = useTranslations()
  const sizePreference = useProjectState('sizePreference')
  const { setActiveLayer } = useSceneActions()
  const { activeLayer } = useActiveLayer()

  const on2DClick = () => {
    setActiveLayer('2D')
  }

  const on3DClick = () => {
    setActiveLayer('3D')
  }

  return (
    <div className={styles['container']}>
      <ActionButton
        size={sizePreference}
        className={styles['button']}
        onClick={on2DClick}
        quiet
        selected={activeLayer === '2D'}
      >
        <Icon slot="icon">
          <TwoDSDFIcon />
        </Icon>
        {t('studio:sceneLayerToggleButton:2d')}
      </ActionButton>

      <ActionButton
        size={sizePreference}
        className={styles['button']}
        quiet
        onClick={on3DClick}
        selected={activeLayer === '3D'}
      >
        <Icon slot="icon">
          <CubeIcon />
        </Icon>
        {t('studio:sceneLayerToggleButton:3d')}
      </ActionButton>
    </div>
  )
}
